module.exports = __webpack_public_path__ + "static/backdrop-7d56032d268c33cf5ca7e73dfd799993.jpg";